import React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <path d="M22,14v6a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2h6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H4V20H20V14a1,1,0,0,1,1-1h0A1,1,0,0,1,22,14ZM20.85,3.15a4,4,0,0,0-5.59,0L7.94,10.47a4.1,4.1,0,0,0-1.32,2.7v3.21a1,1,0,0,0,1,1h3.13A4,4,0,0,0,13.57,16l7.28-7.26A4,4,0,0,0,20.85,3.15ZM11.73,15a2,2,0,0,1-1.43.74H8.24V13.56a2.15,2.15,0,0,1,.7-1.32L15,6.13l2.75,2.76ZM19.2,7.47,16.46,4.73A2,2,0,0,1,19.2,7.47Z" />,
  "GuardianNote"
);
